export default __webpack_public_path__ + "static/media/spring.e59758c7.jpeg";